import React, { PureComponent } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import axios, { post } from 'axios';
import appConstant from '../../../../constants/app';
import InputComponent from '../../../components/baseComponents/input';
import FileComponent from '../../../components/baseComponents/file';

class IconEditModal extends PureComponent {
  state = {
    id: null,
    name: '',
    icon: '',
    iconError: '',
    iconPreview: '',
    iconRemoved: 0,
    defaultToShow: "0",
  }

  refFields = {};
  
  fetchIcon = () => {
    const token = localStorage.getItem('token');
    axios.get(`${appConstant.API_URL}/icon/show/${this.props.iconId}?access_token=${token}`)
    .then(res => res).then(data => {
      const icon = data.data.icon;
      
      return { icon };
    })
    .then(({icon}) => {
      this.setState({
        id: icon.id,
        name: icon.name,
        iconPreview: icon.icon_path,
        defaultToShow: `${icon.default_to_show}`,
      })
    })
    .catch(err => {
      console.log(err);
    });
  }

  componentDidMount() {
    this.fetchIcon();
  }

  onChangeIconFile = (event, index) => {
    this.setState({
      icon: event.target.files[0],
    });
  }

  handleChange = (val, name) => {
    this.setState({[name]: val})
  }

  handleRadioChange = (event) => {
    this.setState({
      defaultToShow: event.target.value
    });
  }

  isValidForm = () => {
    return Object.keys(this.refFields)
      .map(field => this.refFields[field] && this.refFields[field].validate())
      .reduce((sum, validField) => validField != null && sum + (!validField ? 1 : 0), 0) === 0;
  }

  removeIcon = () => {
    this.setState({
      iconRemoved: 1,
      iconPreview: '',
    })
  }

  deleteIcon = () => {
    this.setState({
      iconError: '',
    });
  };

  isValidImage = () => {
    if (this.state.icon) {
      if (this.state.icon.type !== "image/svg+xml") {
        this.setState({iconError: `Incorrect format, you have to upload an svg image.`});
        return false;
      }
      
      this.deleteIcon();
    }

    return true;
  }

  onFormSubmit = async(e) => {
    e.preventDefault()
    const validImage = await this.isValidImage();
    if (!this.isValidForm()) return false;
    if (!validImage) return false;

    const {
      id,
      name,
      icon,
      iconRemoved,
      defaultToShow,
    } = this.state;

    this.uploadData(id, name, icon, iconRemoved, defaultToShow)
      .then(res => {
        this.props.onClose();
        this.props.onAccept();
      })
      .catch(err => {
        console.log(err);
      });
  };

  uploadData = (id, name, icon, iconRemoved, defaultToShow) => {
    const token = localStorage.getItem('token');
    const path = `${appConstant.API_URL}/icon/update?access_token=${token}`;
    const formData = new FormData();

    formData.append('id', id)
    formData.append('name', name)
    formData.append('icon', icon)
    formData.append('remove_icon', iconRemoved)
    formData.append('default_to_show', defaultToShow)

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }

    return post(path, formData, config);
  }

  render () {
    return (
      <div>
        <form onSubmit={this.onFormSubmit}>
          <Row className="link-form-row">
            <Col sm={6}>
              <label>Name</label>
              <InputComponent
                value={this.state.name}
                ref={(input) => { this.refFields.name = input; }}
                inputGroup="name"
                validationRules="required"
                customErrorMessage="Required field"
                placeholder='Name'
                classes='form-control'
                onChange={this.handleChange}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <label>Current Icon</label>
              {
                this.state.iconPreview
                ? <div>
                  <img
                    style={{
                      width: '24px',
                      height: '24px',
                    }}
                    src={this.state.iconPreview}
                    alt=""
                  />
                  {/* <Button
                    style={{
                      border: 'none',
                      fontSize: '24px',
                    }}
                    onClick={this.removeIcon}
                  >
                    <Glyphicon glyph="remove-circle" />
                  </Button> */}
                </div>
                : <div></div>
              }
            </Col>
          </Row>
          <Row style={{ marginTop: '20px', marginBottom: '20px' }}>
            <Col sm={12}>
              <label>Change Icon</label>
              <FileComponent
                onChange={this.onChangeIconFile}
                classes="form-control input-file"
                value={this.state.icon}
                name={`iconFile`}
                ref={(input) => { this.refFields.iconFile = input; }}
                isRequired={false}
              />
              {this.state.iconError && <div className="error-message">{this.state.iconError}</div>}
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <label>Default icon</label>
              <div className="label-option">
                <input
                  className="checkbox-option"
                  type="radio"
                  name="default_to_show"                  
                  value="1"
                  checked={this.state.defaultToShow === "1"}
                  onChange={this.handleRadioChange}
                />
                <div className="title-option">
                  Yes
                </div>
              </div>
              <div className="label-option">
                <input
                  className="checkbox-option"
                  type="radio"
                  name="default_to_show"                  
                  value="0"
                  checked={this.state.defaultToShow === "0"} 
                  onChange={this.handleRadioChange}
                />
                <div className="title-option">
                  No
                </div>
              </div>
            </Col>
          </Row>
          <Row className="confirmation-btns-footer link-form-row">
            <Col sm={12}>
              <Button
                className="cancel-btn"
                onClick={this.props.onClose}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="accept-btn"
              >
                Save changes
              </Button>
            </Col>
          </Row>
          </form>
      </div>
    );
  }
}

export default IconEditModal;



// WEBPACK FOOTER //
// ./src/app/screens/icons/iconsList/iconEditModal.js